import { DirectUpload } from "@rails/activestorage"

const uploadFile = (file, url= null) => {
  // your form needs the file_field direct_upload: true, which
  //  provides data-direct-upload-url
  url = url || `${process.env.VUE_APP_API_ROOT}/direct_uploads` || 'http://localhost:3000/api/v1/direct_uploads'

  // console.log({file, url});

  const upload = new DirectUpload(file, url)

  return new Promise((resolve, reject)=>{
    upload.create((error, blob) => {
      if (error) {
        console.log({error});
        reject(
          error
        )
      } else {
        // console.log({blob});
        resolve(
          blob
        )
      }
    })
  })
}

export default uploadFile
